/**
 * Referral Records master-specific translation keys
 */
export const referralRecord = {
  list: {
    main_heading: "admin.referral_record_list_heading",
    search_placeholder: "admin.referral_record_search_placeholder",
    table: {
      referral_date_col_heading: "admin.referral_record_table_referral_date_col_heading",
      referrer_name_col_heading: "admin.referral_record_table_referrer_name_col_heading",
      referrer_email_col_heading: "admin.referral_record_table_referrer_email_col_heading",
      invited_name_col_heading: "admin.referral_record_table_invited_name_col_heading",
      invited_email_col_heading: "admin.referral_record_table_invited_email_col_heading",
      country_col_heading: "admin.referral_record_table_country_col_heading",
      city_col_heading: "admin.referral_record_table_city_col_heading",
      active_status_col_heading: "admin.referral_record_table_active_status_col_heading",
      reward_status_col_heading: "admin.referral_record_table_reward_status_col_heading",
      action_col_heading: "admin.referral_record_table_action_col_heading",
    },
    active_status_filter: {
      all: "admin.referral_record_active_status_filter_all",
      active: "admin.referral_record_active_status_active",
      not_active: "admin.referral_record_active_status_not_active",
    },
    reward_status: {
      pending: "admin.referral_record_reward_status_pending",
      rewarded: "admin.referral_record_reward_status_rewarded",
    },
    country_filter_placeholder: "admin.referral_record_country_filter_placeholder",
    date_from_placeholder: "admin.referral_record_date_from_placeholder",
    date_to_placeholder: "admin.referral_record_date_to_placeholder",
    clear_filter_btn_text: "admin.referral_record_clear_filter_btn_text",
    view_tooltip: "admin.referral_record_view_tooltip",
    flag_fraudulent_tooltip: "admin.referral_record_flag_fraudulent_tooltip",
    already_flagged_tooltip: "admin.referral_record_already_flagged_tooltip",
    defaults: {
      na: "admin.referral_record_defaults_na",
    },
  },
  view: {
    main_heading: "admin.referral_record_view_heading",
    back_to_list: "admin.referral_record_back_to_list",
    error: {
      not_found: "admin.referral_record_not_found_heading",
      not_found_description: "admin.referral_record_not_found_description",
    },
    tabs: {
      referrer_info: "admin.referral_record_tab_referrer_info",
      invited_user_info: "admin.referral_record_tab_invited_user_info",
      reward_history: "admin.referral_record_tab_reward_history",
    },
    actions: {
      mark_fraudulent: "admin.referral_record_mark_fraudulent_btn",
    },
    mark_fraudulent_popup: {
      heading: "admin.referral_record_mark_fraudulent_popup_heading",
      message: "admin.referral_record_mark_fraudulent_popup_message",
      reason_placeholder: "admin.referral_record_mark_fraudulent_reason_placeholder",
      reason_required: "admin.referral_record_mark_fraudulent_reason_required",
      yes_btn_text: "admin.referral_record_mark_fraudulent_popup_yes_btn_text",
      no_btn_text: "admin.referral_record_mark_fraudulent_popup_no_btn_text",
    },
    messages: {
      mark_fraudulent_success: "admin.referral_record_mark_fraudulent_success",
    },
    referrer_info: {
      title: "admin.referral_record_referrer_info_title",
      referral_code_label: "admin.referral_record_referral_code_label",
      referral_link_label: "admin.referral_record_referral_link_label",
      copy_link_btn: "admin.referral_record_copy_link_btn",
      copy_success: "admin.referral_record_copy_link_success",
      copy_code_btn: "admin.referral_record_copy_code_btn",
      copy_code_success: "admin.referral_record_copy_code_success",
      total_invited_label: "admin.referral_record_total_invited_label",
      total_active_referrals_label: "admin.referral_record_total_active_referrals_label",
      premium_months_earned_label: "admin.referral_record_premium_months_earned_label",
      leaderboard_rank_title: "admin.referral_record_leaderboard_rank_title",
      leaderboard_city_label: "admin.referral_record_leaderboard_city_label",
      leaderboard_country_label: "admin.referral_record_leaderboard_country_label",
      leaderboard_global_label: "admin.referral_record_leaderboard_global_label",
    },
    invited_user_info: {
      title: "admin.referral_record_invited_user_info_title",
      name_label: "admin.referral_record_invited_name_label",
      email_label: "admin.referral_record_invited_email_label",
      registration_date_label: "admin.referral_record_invited_registration_date_label",
      active_status_label: "admin.referral_record_invited_active_status_label",
      active_at_label: "admin.referral_record_invited_active_at_label",
    },
    reward_history: {
      title: "admin.referral_record_reward_history_title",
      table: {
        label_col_heading: "admin.referral_record_reward_history_table_label_col_heading",
        reason_col_heading: "admin.referral_record_reward_history_table_reason_col_heading",
        months_granted_col_heading: "admin.referral_record_reward_history_table_months_granted_col_heading",
        earned_at_col_heading: "admin.referral_record_reward_history_table_earned_at_col_heading",
      },
    },
    defaults: {
      na: "admin.referral_record_defaults_na",
    },
  },
};